module.exports = __webpack_public_path__ + "img/deportivo-alaves-logo-icon.3b437b58.png";